import { getAxiosInstance } from "../blocks/axios/axiosFactory";
import { LoginRequest } from "../models/auth/login/LoginRequest";

const url = "/auth";

export default class AuthService {
  static login(request: LoginRequest) {
    return getAxiosInstance().post(`${url}/login`, { ...request });
  }

  static logout() {
    return getAxiosInstance().post(`${url}/logout`);
  }

  static isAuthenticated() {
    return getAxiosInstance().get(`${url}/isAuthenticated`);
  }
}
